/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/iframe-has-title */
export const MapBoxGiaLoc = () => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.9747546624917!2d106.29224087502695!3d20.873067780737692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31359b262ae69b8b%3A0xd59250ced26ade6b!2zWeG6v3QgS2nDqnUsIHR0LiBHaWEgTOG7mWMsIEjhuqNpIETGsMahbmcsIFZp4buHdCBOYW0!5e0!3m2!1svi!2s!4v1715613838459!5m2!1svi!2s"
      width="100%"
      height="550"
      style={{ border: 0 }}
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};
